module.exports = __webpack_public_path__ + "static/media/icoke-logo.1b0f13a4.png";